import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5f21b30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"width":"100%"},
  class: "shopcard-container"
}
const _hoisted_2 = { class: "shopcard" }
const _hoisted_3 = { class: "p-d-flex p-jc-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-6 p-mt-2" }, " * Campi obbligatori ", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-column p-ai-center",
  style: {"width":"100%"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sembra tu non abbia nessun negozio...", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Comincia ad aggiungerli!", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "store-registration-buttons"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " * Campi obbligatori ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShopCardInsertion = _resolveComponent("ShopCardInsertion")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": _ctx.isLoading }, {
    default: _withCtx(() => [
      (_ctx.store.state.signupForm.storeList?.poses?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.signupForm.storeList.poses, (shop) => {
              return (_openBlock(), _createBlock(_component_Card, {
                key: shop.shopData.shopId
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ShopCardInsertion, {
                      "show-avatar": _ctx.props.showAvatar,
                      "shop-id": shop.shopData.shopId,
                      data: shop.shopData,
                      "disable-fields": _ctx.props.disableFields,
                      onIsValid: _ctx.isValid
                    }, null, 8 /* PROPS */, ["show-avatar", "shop-id", "data", "disable-fields", "onIsValid"]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_Button, {
                        class: "delete_icon gv-button",
                        icon: "pi pi-trash",
                        disabled: _ctx.props.disableFields,
                        onClick: () => _ctx.deleteShop(shop.shopData.shopId)
                      }, null, 8 /* PROPS */, ["disabled", "onClick"])
                    ])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */)),
            _hoisted_4
          ]))
        : (!_ctx.props.fetchData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("v-if", true),
      (!_ctx.isInProfileView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "gv-button",
                disabled: _ctx.props.disableFields,
                onclick: _ctx.addNewEmptyShop,
                label: "Aggiungi punto vendita *"
              }, null, 8 /* PROPS */, ["disabled", "onclick"])
            ]),
            _hoisted_10
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-loading"]))
}